<template>
  <el-dialog title="个人信息" :visible.sync="visible" :append-to-body="true">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="140px">
      <el-form-item label="账号">
        <span>{{ userName }}</span>
      </el-form-item>
      <el-form-item label="账号名称" prop="nickName">
        <el-input style="width: 60%" v-model="nickName" placeholder="请输入内容(15字内)"></el-input>
      </el-form-item>
      <el-form-item label="工作区" prop="workingSpace">
        <el-input style="width: 60%" v-model="workingSpace" placeholder="请输入内容(10字内)"></el-input>
      </el-form-item>
      <el-form-item v-if="placeId" label="购药二维码下载">
        <!--<el-image-->
        <!--style="width: 100px; height: 100px"-->
        <!--:src="drugOrgaDownewmSrc()"></el-image>-->

        <el-button size="small" icon="el-icon-full-screen" @click="drugOrgaDownewm(placeId)">二维码下载</el-button>
      </el-form-item>
      <el-form-item v-if="samplingSite" label="采样点二维码下载">
        <!--<el-image-->
        <!--style="width: 100px; height: 100px"-->
        <!--:src="colpointDownewmSrc()"></el-image>-->
        <el-button size="small" icon="el-icon-full-screen" @click="colpointDownewm(samplingSite)">二维码下载</el-button>
      </el-form-item>
      <el-form-item label="创建时间">
        <span>{{ createTime }}</span>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      dataForm: {},
      dataRule: {},
    };
  },
  computed: {
    userName: {
      get() {
        return this.$store.state.user.name;
      },
    },
    mainTabs: {
      get() {
        return this.$store.state.common.mainTabs;
      },
      set(val) {
        this.$store.commit("common/updateMainTabs", val);
      },
    },
    sidebarFold: {
      get() {
        return this.$store.state.common.sidebarFold;
      },
    },
    userId: {
      get() {
        return this.$store.state.user.id;
      },
      set(val) {
        this.$store.commit("user/updateId", val);
      },
    },
    workingSpace: {
      get() {
        return this.$store.state.user.workingSpace;
      },
      set(val) {
        this.$store.commit("user/setWorkingSpace", val);
      },
    },
    nickName: {
      get() {
        return this.$store.state.user.nickName;
      },
      set(val) {
        this.$store.commit("user/setNickName", val);
      },
    },
    createTime: {
      get() {
        return this.$store.state.user.createTime;
      },
      set(val) {
        this.$store.commit("user/setCreateTime", val);
      },
    },
    placeId: {
      get() {
        return this.$store.state.user.placeId;
      },
    },
    samplingSite: {
      get() {
        return this.$store.state.user.samplingSite;
      },
    },
  },
  methods: {
    // 初始化
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
      });
    },
    // 表单提交
    dataFormSubmit() {
      if (this.nickName.length > 15) {
        this.$message.warning("账号名称请输入15字以内");
        return;
      }
      if (this.workingSpace.length > 10) {
        this.$message.warning("工作区请输入10字以内");
        return;
      }
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl("/sys/user/update_self"),
            method: "post",
            data: this.$http.adornData({
              workingSpace: this.workingSpace,
              nickName: this.nickName,
            }),
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },

    colpointDownewmSrc() {
      return (
        window.SITE_CONFIG.baseUrl +
        "/api/detection/buying_place/download?id=" +
        this.samplingSite
      );
    },
    drugOrgaDownewmSrc() {
      return (
        window.SITE_CONFIG.baseUrl +
        "/api/detection/buying_place/download?id=" +
        this.placeId
      );
    },
    drugOrgaDownewm(plaId) {
      this.$http({
        url: this.$http.adornUrl(
          "/api/detection/buying_place/download?id=" + plaId
        ),
        method: "post",
        responseType: "blob",
        timeout: 30000000,
      })
        .then((response) => {
          console.log(response);
          const blob = new Blob([response.data], {
            type: "image/png",
          });
          let fileName = "二维码.png";
          if ("download" in document.createElement("a")) {
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            navigator.msSaveBlob(blob, fileName);
          }
        })
        .catch((error) => {
          console.log("接口异常");
          // reject(error)
        });
    },
    colpointDownewm(colId) {
      this.$http({
        url: this.$http.adornUrl(
          "/api/detection/detection_locale/download?id=" + colId
        ),
        method: "post",
        responseType: "blob",
        timeout: 30000000,
      })
        .then((response) => {
          console.log(response);
          const blob = new Blob([response.data], {
            type: "image/png",
          });
          let fileName = "图片";
          if ("download" in document.createElement("a")) {
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            navigator.msSaveBlob(blob, fileName);
          }
        })
        .catch((error) => {
          console.log("接口异常");
          // reject(error)
        });
    },
  },
};
</script>

